import React, { useEffect, useState } from 'react'
import ReRegLaunchForm from './ReRegLaunchForm'
import { GetReRegNotSubmitReasonsList } from '../../services/ReRegistrationService';
import { useDispatch, useSelector } from 'react-redux';
import { setIsReReg } from '../../store/actions';
import { useHistory } from 'react-router-dom';

const SoftAndHardLaunch = () => {
    const [reasonDropdownData, setReasonDropdownData] = useState([]);
    const dispatch = useDispatch();
    const history = useHistory();
    const examsList = useSelector(state => state.registrations.data);    
    const reload = useSelector(state => state.registrations.reload);
    
    useEffect(() => {
        let isMounted = true;
        if(examsList.length){
            const status = examsList.length > 0 ;
            dispatch(setIsReReg(status));
        }else{
            dispatch(setIsReReg(false));
            history.push('/home')
        }
        
        GetReRegNotSubmitReasonsList()
        .then(res => {
            if (!isMounted) return;
            setReasonDropdownData(res?.data?.data.map(item=>({value:item?.id.toString(), label: item?.reason})));
        })
        .catch(error => {
            console.error(error);
        });
        return () => {
            isMounted = false;
        };
    }, [reload]);
    return (
        <div className="launch__wrappper border-0">
            {examsList.length ? examsList.map((item,ind)=><ReRegLaunchForm key={ind} data={item} reasonDropdownData={reasonDropdownData}/>) : ""}
        </div>)
    }
    
    export default SoftAndHardLaunch